import { render, staticRenderFns } from "./EditAutoDeliveryCancel.vue?vue&type=template&id=6aa4560c&scoped=true&lang=pug&"
import script from "./EditAutoDeliveryCancel.vue?vue&type=script&lang=js&"
export * from "./EditAutoDeliveryCancel.vue?vue&type=script&lang=js&"
import style0 from "./EditAutoDeliveryCancel.vue?vue&type=style&index=0&id=6aa4560c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa4560c",
  null
  
)

export default component.exports